import { createStylesContext } from '@chakra-ui/system';

export const COMPONENT_NAME = 'Callout';

export const [StylesProvider, useStyles] = createStylesContext(COMPONENT_NAME);
